export const STEPS = {
  ENTER_DOMAIN: 'ENTER_DOMAIN',
  PLANTURBO_FREE_DOMAIN: 'PLANTURBO_FREE_DOMAIN',
  SUCCESS: 'SUCCESS',
};

export const initialStep = STEPS.ENTER_DOMAIN;
